import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import { CDN_LINK } from "@globalConfig";
import LimitedAvaPostViewBtn from "@/pages/post/PostViewComponents/components/leftColumn/components/limitedAvailability/limitedAvailabilityComponent/LimitedAvaPostViewBtn";
import stl from "../cashPayment/CashPayment.module.css";
import ProgressiveImage from "@componentsShared/ProgressiveImage";
import { useEffect, useState } from "react";
import PaymentTabBoxPopup from "@/pages/post/PostViewComponents/components/leftColumn/components/paymentTabBox/PaymentTabBoxPopup";
import InstallmentCalculatorView from "@/_MiniApps/Installment-calculator/InstallmentCalculatorView";
import InstallmentCalculatorTerms from "@/_MiniApps/Installment-calculator/InstallmentCalculatorTerms";
import { BottomSheet } from "@componentsShared/BottomSheet";
import useBoolean from "@hooks/useBoolean";
import { trackEvents } from "@/common/events/events";
import CarColorVariation from "@/pages/post/PostViewComponents/components/CarColorVariation/CarColorVariation";
import useIsMobile from "@hooks/useIsMobile";
import useHelpers from "@hooks/useHelpers";
var LimitedAvailability = function LimitedAvailability(_ref) {
  var _post$details_card, _post$details, _priceSection$vat_pri, _priceSection$old_pri, _priceSection$old_pri2, _priceSection$finance, _priceSection$finance2, _priceSection$finance3, _priceSection$vat_pri2, _post$color_variants, _post$details_card2, _post$details_card2$e, _post$details_card3, _post$details_card3$e;
  var priceSection = _ref.priceSection,
    postId = _ref.postId,
    footer_section = _ref.footer_section,
    desktop = _ref.desktop,
    g4_data = _ref.g4_data,
    _ref$have_finance = _ref.have_finance,
    have_finance = _ref$have_finance === void 0 ? false : _ref$have_finance,
    isUsed = _ref.isUsed,
    post = _ref.post;
  var _useTranslation = useTranslation(["web_post_view", "web_common"]),
    t = _useTranslation.t;
  var _useState = useState(false),
    showPaymentTabBoxPopup = _useState[0],
    setShowPaymentTabBoxPopup = _useState[1];
  var _useBoolean = useBoolean(),
    isCalculatorOpen = _useBoolean.value,
    openCalculator = _useBoolean.setTrue,
    closeCalculator = _useBoolean.setFalse;
  var car_condition = !(post !== null && post !== void 0 && (_post$details_card = post.details_card) !== null && _post$details_card !== void 0 && _post$details_card.is_new.id) ? "used" : post !== null && post !== void 0 && (_post$details = post.details) !== null && _post$details !== void 0 && _post$details.is_chinese ? "chinese" : "new";
  var _useState2 = useState(false),
    hasInteracted = _useState2[0],
    setHasInteracted = _useState2[1];
  var isMobile = useIsMobile();
  var _useHelpers = useHelpers(),
    navigateToHard = _useHelpers.navigateToHard;
  var showImagesDisclaimer = function showImagesDisclaimer() {
    var _post$gallery, _post$gallery$images;
    if ((post === null || post === void 0 ? void 0 : (_post$gallery = post.gallery) === null || _post$gallery === void 0 ? void 0 : (_post$gallery$images = _post$gallery.images) === null || _post$gallery$images === void 0 ? void 0 : _post$gallery$images.length) > 0) {
      var _post$gallery$images2, _post$gallery$images3, _post$gallery$images4, _post$gallery$images5;
      var exteriorImages = post === null || post === void 0 ? void 0 : (_post$gallery$images2 = post.gallery.images) === null || _post$gallery$images2 === void 0 ? void 0 : (_post$gallery$images3 = _post$gallery$images2.filter(function (item) {
        return (item === null || item === void 0 ? void 0 : item.img_type) === "exterior";
      })) === null || _post$gallery$images3 === void 0 ? void 0 : _post$gallery$images3.length;
      var interiorImages = post === null || post === void 0 ? void 0 : (_post$gallery$images4 = post.gallery.images) === null || _post$gallery$images4 === void 0 ? void 0 : (_post$gallery$images5 = _post$gallery$images4.filter(function (item) {
        return (item === null || item === void 0 ? void 0 : item.img_type) === "interior";
      })) === null || _post$gallery$images5 === void 0 ? void 0 : _post$gallery$images5.length;
      return exteriorImages < 5 || interiorImages < 5;
    }
    return false;
  };
  var handleFirstInteraction = function handleFirstInteraction(_ref2) {
    var field = _ref2.field;
    if (hasInteracted) {
      setHasInteracted(false);
      trackEvents("finance_calculator_interact", _objectSpread(_objectSpread({}, g4_data), {}, {
        post_trim: g4_data === null || g4_data === void 0 ? void 0 : g4_data.post_ext,
        field_interaction: field
      }));
    }
  };
  useEffect(function () {
    if (isCalculatorOpen) {
      setHasInteracted(true);
    } else {
      setHasInteracted(false);
    }
  }, [isCalculatorOpen]);
  var handleCalculatorClick = function handleCalculatorClick() {
    openCalculator();
    trackEvents("finance_calculator_open", _objectSpread(_objectSpread({}, g4_data), {}, {
      post_trim: g4_data === null || g4_data === void 0 ? void 0 : g4_data.post_ext
    }));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.container
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.newPriceFlx
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: stl.flexColumn
  }, /*#__PURE__*/React.createElement("strong", {
    className: stl.title
  }, t("السعر يبدأ من", {
    ns: "web_post_view"
  })), /*#__PURE__*/React.createElement("strong", {
    className: stl.priceCashON
  }, priceSection === null || priceSection === void 0 ? void 0 : (_priceSection$vat_pri = priceSection.vat_price) === null || _priceSection$vat_pri === void 0 ? void 0 : _priceSection$vat_pri.text, /*#__PURE__*/React.createElement("span", null, priceSection === null || priceSection === void 0 ? void 0 : priceSection.currency))), (priceSection === null || priceSection === void 0 ? void 0 : (_priceSection$old_pri = priceSection.old_price) === null || _priceSection$old_pri === void 0 ? void 0 : _priceSection$old_pri.text_with_vat) && /*#__PURE__*/React.createElement("strong", {
    className: [stl.priceCashON, stl.oldPrice].join(" ")
  }, priceSection === null || priceSection === void 0 ? void 0 : (_priceSection$old_pri2 = priceSection.old_price) === null || _priceSection$old_pri2 === void 0 ? void 0 : _priceSection$old_pri2.text_with_vat, /*#__PURE__*/React.createElement("span", null, priceSection === null || priceSection === void 0 ? void 0 : priceSection.currency))), /*#__PURE__*/React.createElement("div", null, have_finance && (priceSection === null || priceSection === void 0 ? void 0 : (_priceSection$finance = priceSection.finance_price) === null || _priceSection$finance === void 0 ? void 0 : _priceSection$finance.text) && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: stl.newKastContainer,
    onClick: function onClick() {
      return handleCalculatorClick();
    }
  }, /*#__PURE__*/React.createElement("strong", {
    className: stl.NKTitle
  }, t("يبدأ القسط من", {
    ns: "web_post_view"
  })), /*#__PURE__*/React.createElement("strong", {
    className: stl.NKPrice
  }, priceSection === null || priceSection === void 0 ? void 0 : (_priceSection$finance2 = priceSection.finance_price) === null || _priceSection$finance2 === void 0 ? void 0 : _priceSection$finance2.text, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", {
    className: "text-xl"
  }, t("ريال", {
    ns: "web_post_view"
  })), /*#__PURE__*/React.createElement("span", null, t("/ شهرياً", {
    ns: "web_post_view"
  })), (priceSection === null || priceSection === void 0 ? void 0 : (_priceSection$finance3 = priceSection.finance_price) === null || _priceSection$finance3 === void 0 ? void 0 : _priceSection$finance3.text) && showPaymentTabBoxPopup && /*#__PURE__*/React.createElement(PaymentTabBoxPopup, {
    priceSection: priceSection,
    onClose: function onClose() {
      return setShowPaymentTabBoxPopup(false);
    },
    isUsed: isUsed
  }))), /*#__PURE__*/React.createElement("strong", {
    className: stl.NewOpenKastDetails
  }, /*#__PURE__*/React.createElement(ProgressiveImage, {
    width: 16,
    height: 16,
    waitUntilInteractive: true,
    src: CDN_LINK + "/assets/images/arithmetic.svg",
    alt: "arrow"
  }), /*#__PURE__*/React.createElement("span", {
    className: stl.underline
  }, t("احسب التمويل", {
    ns: "web_post_view"
  }))))))), /*#__PURE__*/React.createElement("div", {
    className: stl.note
  }, /*#__PURE__*/React.createElement("span", {
    className: stl.smlNoteN
  }, /*#__PURE__*/React.createElement("img", {
    width: "12px",
    src: CDN_LINK + "/assets/images/GreyCheck.svg",
    alt: "tik"
  }), /*#__PURE__*/React.createElement("span", null, priceSection === null || priceSection === void 0 ? void 0 : (_priceSection$vat_pri2 = priceSection.vat_price) === null || _priceSection$vat_pri2 === void 0 ? void 0 : _priceSection$vat_pri2.header, " "))), /*#__PURE__*/React.createElement(BottomSheet, {
    open: isCalculatorOpen,
    onOpen: openCalculator,
    onClose: closeCalculator,
    screens: [{
      title: t('احسب قيمة التمويل', {
        ns: 'web_post_view'
      }),
      component: /*#__PURE__*/React.createElement(InstallmentCalculatorView, {
        carCondition: car_condition,
        cashPrice: priceSection === null || priceSection === void 0 ? void 0 : priceSection.vat_price.text.replace(/,/g, ""),
        onClose: closeCalculator,
        onInteraction: handleFirstInteraction
      })
    }, {
      title: t('شروط التمويل', {
        ns: "web_post_view"
      }),
      component: /*#__PURE__*/React.createElement(InstallmentCalculatorTerms, null)
    }]
  }), isMobile && (post === null || post === void 0 ? void 0 : (_post$color_variants = post.color_variants) === null || _post$color_variants === void 0 ? void 0 : _post$color_variants.length) > 0 && /*#__PURE__*/React.createElement("div", {
    className: "w-full mb-4"
  }, /*#__PURE__*/React.createElement(CarColorVariation, {
    colors: post === null || post === void 0 ? void 0 : post.color_variants,
    onColorClick: function onColorClick(color) {
      var _color$name_en;
      trackEvents("car_color_selected", {
        referral_location: "post_details",
        post_id: postId,
        selected_color: (_color$name_en = color === null || color === void 0 ? void 0 : color.name_en) !== null && _color$name_en !== void 0 ? _color$name_en : '',
        post_make: g4_data === null || g4_data === void 0 ? void 0 : g4_data.post_make,
        post_model: g4_data === null || g4_data === void 0 ? void 0 : g4_data.post_model
      });
      navigateToHard("/cardetail/".concat(color.post_id));
    },
    currentColorCode: post === null || post === void 0 ? void 0 : (_post$details_card2 = post.details_card) === null || _post$details_card2 === void 0 ? void 0 : (_post$details_card2$e = _post$details_card2.exterior_color) === null || _post$details_card2$e === void 0 ? void 0 : _post$details_card2$e.code,
    currentColorName: post === null || post === void 0 ? void 0 : (_post$details_card3 = post.details_card) === null || _post$details_card3 === void 0 ? void 0 : (_post$details_card3$e = _post$details_card3.exterior_color) === null || _post$details_card3$e === void 0 ? void 0 : _post$details_card3$e.name,
    showDisclaimer: showImagesDisclaimer()
  })), desktop &&
  /*#__PURE__*/
  /*@fixme limited*/
  React.createElement(LimitedAvaPostViewBtn, {
    footer_section: footer_section,
    postId: postId,
    g4_data: g4_data,
    desktop: desktop,
    have_finance: have_finance,
    post: post
  })));
};
export default LimitedAvailability;